(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('exercises', {
            parent: 'app',
            url: '/admin/exercises',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/exercise/exercise.html',
                    controller: 'ExerciseController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('exercises-detail', {
            parent: 'app',
            url: '/admin/exercises/:id',
            data: {
                roles: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/exercise/exercise-detail.html',
                    controller: 'ExerciseDetailController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
